module.exports = __webpack_public_path__ + "static/star-94490e6fc64a0f367fc6e0de7e4e2123.svg";